export function unique(array) {
    return [...new Set(array)];
}
//# sourceMappingURL=unique.js.map